import { stdObject } from "../../../../data/types/stdObject";

export const writeMovementsBatches = ({
  id,
  searchValues,
  responseReportData,
  itemsList,
}: stdObject) => {
  let results: stdObject = responseReportData.batches.map((e: stdObject) => {
    console.log(itemsList[e.ARTBA1]);
    e.DESBA1 = itemsList[e.ARTBA1]?.NOMART;
    e.DISBA1 = e.INBA1 - e.OUTBA1;
    return e;
  });

  return {
    ...searchValues,
    [id]: {
      ...searchValues[id],
      results,
    },
  };
};
